import produce from 'immer';

import {
  GET_ALL_CHALLENGES_REQUEST,
  GET_ALL_CHALLENGES_SUCCESS,
  GET_ALL_CHALLENGES_FAILURE,
  SET_FILTERS,
} from './constants';

const initialState = {
  loading: false,
  challenges: [],
  selectedTagFilters: ['Official'],
  error: '',
};

export default (baseState = initialState, action) => {
  return produce(baseState, (state) => {
    switch (action.type) {
      case GET_ALL_CHALLENGES_REQUEST:
        state.loading = true;
        state.error = '';
        break;
      case GET_ALL_CHALLENGES_SUCCESS:
        state.loading = false;
        state.error = '';
        state.challenges = action.challenges;
        break;
      case GET_ALL_CHALLENGES_FAILURE:
        state.loading = false;
        state.error = action.error;
        break;
      case SET_FILTERS:
        state.selectedTagFilters = action.filters;
        break;
      default:
        break;
    }
  });
};
